<template>
    <div class="px-3">
        <v-row v-if="selected_months.length > 0">
            <v-col cols="3"> </v-col>
            <v-col cols="3" justify="center" align="center"> 
                <v-row justify="center" align="center">
                    <h5 class="pb-2">{{ selected_months[0][$store.state.language] }}</h5> 
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="!month1.sorted" @click="month1.sorted = true; month1.direction = 'desc'; sortResults(data, year.toString() + '-' + String(selected_months[0].month + 1).padStart(2, '0'), 'desc', 'month1')">
                        <v-icon>unfold_more</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month1.sorted && month1.direction == 'desc'" @click="month1.sorted = true; month1.direction = 'asc'; sortResults(data, year.toString() + '-' + String(selected_months[0].month + 1).padStart(2, '0'), 'asc', 'month1')">
                        <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month1.sorted && month1.direction == 'asc'" @click="month1.sorted = false; month1.direction = ''; sortResults(data, null, '', 'month1')">
                        <v-icon>keyboard_arrow_up</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
            <v-col cols="3" justify="center" align="center"> 
                <v-row justify="center" align="center">
                    <h5 class="pb-2">{{ selected_months[1][$store.state.language] }}</h5> 
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="!month2.sorted" @click="month2.sorted = true; month2.direction = 'desc'; sortResults(data, year.toString() + '-' + String(selected_months[1].month + 1).padStart(2, '0'), 'desc', 'month2')">
                        <v-icon>unfold_more</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month2.sorted && month2.direction == 'desc'" @click="month2.sorted = true; month2.direction = 'asc'; sortResults(data, year.toString() + '-' + String(selected_months[1].month + 1).padStart(2, '0'), 'asc', 'month2')">
                        <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                    <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month2.sorted && month2.direction == 'asc'" @click="month2.sorted = false; month2.direction = ''; sortResults(data, null, '', 'month2')">
                        <v-icon>keyboard_arrow_up</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
            <v-col cols="3" justify="center" align="center"> 
                <v-row>
                    <v-col cols="10" class="pl-12">
                        <v-row justify="center" align="center">
                            <h5 class="pb-2">{{ selected_months[2][$store.state.language] }}</h5>
                            <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="!month3.sorted" @click="month3.sorted = true; month3.direction = 'desc'; sortResults(data, year.toString() + '-' + String(selected_months[2].month + 1).padStart(2, '0'), 'desc', 'month3')">
                                <v-icon>unfold_more</v-icon>
                            </v-btn>
                            <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month3.sorted && month3.direction == 'desc'" @click="month3.sorted = true; month3.direction = 'asc'; sortResults(data, year.toString() + '-' + String(selected_months[2].month + 1).padStart(2, '0'), 'asc', 'month3')">
                                <v-icon>keyboard_arrow_down</v-icon>
                            </v-btn>
                            <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" v-if="month3.sorted && month3.direction == 'asc'" @click="month3.sorted = false; month3.direction = ''; sortResults(data, null, '', 'month3')">
                                <v-icon>keyboard_arrow_up</v-icon>
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-col cols="1" class="px-0 mx-0 py-0 mb-2">
                        <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" @click="leftMonth">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" class="px-0 mx-0 py-0 mb-2">
                        <v-btn small text style="max-width: 15px; min-width: 15px;" class="pb-2" @click="rightMonth">
                            <v-icon>chevron_right</v-icon>    
                        </v-btn>
                    </v-col>
                </v-row>    
            </v-col>
        </v-row>

        <div class="horizontal-separator-bold"></div>

        <v-row class="py-0 my-0" style="font-weight: bold;">
            <v-col class="py-0"> <h5>{{ $t('yego_dashboard.state')}}</h5> </v-col>
            <v-col cols="3"> 
                <v-row justify="center">
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.total_nominal')}}</h5> </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.total_percentage')}}</h5> </v-col>
                </v-row>
            </v-col>
            <v-col cols="3"> 
                <v-row justify="center">
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.total_nominal')}}</h5> </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.total_percentage')}}</h5> </v-col>
                </v-row>
            </v-col>
            <v-col cols="3"> 
                <v-row justify="center">
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.total_nominal')}}</h5> </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="5" justify="center" class="py-0" align="center"> <h5>{{ $t('yego_dashboard.total_percentage')}}</h5> </v-col>
                </v-row>
            </v-col>
        </v-row>

        <div class="horizontal-separator-bold"></div>

        <!-- Total -->
        <span style="font-size: 12px;" v-if="data != null">
            <v-row v-if="showed_options.length > 1">
                <v-col cols="3" class="pl-6">
                    <h4>{{ $t('yego_dashboard.total_mex') }}</h4>
                </v-col>
                <v-col cols="3" v-for="(month, i) in selected_months" :key="i">
                    <span v-for="(date, index) in totals" :key="index">
                        <v-row v-if="(parseInt(month.month) + 1) == parseInt(index.split('-')[1])">
                            <v-col cols="5" justify="center" align="center"> 
                                {{ date.total_shipments }}
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" justify="center" align="center" v-if="date.total_shipments > 0">
                                100.00%
                            </v-col>
                            <v-col cols="5" justify="center" align="center" v-else>
                                0.00%
                            </v-col>
                        </v-row>
                    </span>
                    <v-row v-if="!(year.toString() + '-' + String(month.month + 1).padStart(2, '0') in totals)" style="font-weight: bold;">
                        <v-col cols="5" justify="center" align="center"> 
                            <v-icon small>horizontal_rule</v-icon>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="5" justify="center" align="center">
                            <v-icon small>horizontal_rule</v-icon>                                
                        </v-col>
                    </v-row>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <v-row v-for="prop in showed_options" :key="prop" class="py-0 my-0">
                <v-col cols="3" class="py-0 my-0 pl-6" v-if="showed_options.length > 1">
                    {{ $t('yego_dashboard.totals_' + prop) }}
                </v-col>
                <v-col cols="3" class="py-0 my-0 pl-6" v-else>
                    <h4>{{ $t('yego_dashboard.total_mex') }}</h4>
                </v-col>
                <v-col cols="3" v-for="(month, i) in selected_months" :key="i" class="py-0 my-0">
                    <span v-for="(date, subKey) in totals" :key="subKey">
                        <v-row v-if="(parseInt(month.month) + 1) == parseInt(subKey.split('-')[1])" style="font-weight: bold;" :class="prop == 'delivered' ? calculateClass(parseFloat(date[prop + '_pct'].replace('%', ''))) : ''">
                            <v-col cols="5" justify="center" align="center"> 
                                {{ date[prop + '_total'] }}
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" justify="center" align="center">
                                {{ date[prop + '_pct'] }}
                            </v-col>
                        </v-row>
                    </span>
                    <v-row v-if="!(year.toString() + '-' + String(month.month + 1).padStart(2, '0') in totals)" style="font-weight: bold;">
                        <v-col cols="5" justify="center" align="center"> 
                            <v-icon small>horizontal_rule</v-icon>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="5" justify="center" align="center">
                            <v-icon small>horizontal_rule</v-icon>                                
                        </v-col>
                    </v-row>
                
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <div class="horizontal-separator"></div>
        </span>

        <!-- Calculated Rows -->
        <span v-for="(state, index) in info" :key="index" style="font-size: 12px;">
            <v-row v-if="showed_options.length > 1">
                <v-col cols="3" class="pl-6" justify="center" aling="center">
                    <v-row class="px-0 mx-0 py-0 my-0">
                        <h4>{{ index }}</h4> 
                        <v-icon class="px-1" style="padding-bottom: 3px;" small color="yellow" v-if="index == state_with_most_deliveries.name">star_outline</v-icon>
                    </v-row>
                </v-col>
                    <v-col cols="3" v-for="(month, i) in selected_months" :key="i">
                        <span v-for="(date, subKey) in state" :key="subKey">
                            <v-row v-if="(parseInt(month.month) + 1) == parseInt(subKey.split('-')[1])">
                                <v-col cols="5" justify="center" align="center"> 
                                    {{ date.total_shipments }}
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="5" justify="center" align="center">
                                    {{ ((100 / totals[subKey].total_shipments) * date.total_shipments).toFixed(2) }}%
                                </v-col>
                            </v-row>
                        </span>
                        <v-row v-if="!(year.toString() + '-' + String(month.month + 1).padStart(2, '0') in state)" style="font-weight: bold;">
                            <v-col cols="5" justify="center" align="center"> 
                                <v-icon small>horizontal_rule</v-icon>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" justify="center" align="center">
                                <v-icon small>horizontal_rule</v-icon>                                
                            </v-col>
                        </v-row>
                    </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <v-row v-for="prop in showed_options" :key="prop" class="py-0 my-0">
                <v-col cols="3" class="py-0 my-0 pl-6" v-if="showed_options.length > 1">
                    {{ $t('yego_dashboard.' + prop) }}
                </v-col>
                <v-col cols="3" class="py-0 my-0 pl-6" v-else>
                    <v-row class="px-0 mx-0 py-0 my-0">
                        <h4>{{ index }}</h4> 
                        <v-icon class="px-1" style="padding-bottom: 3px;" small color="yellow" v-if="index == state_with_most_deliveries.name">star_outline</v-icon>
                    </v-row>
                </v-col>
                <v-col cols="3" v-for="(month, i) in selected_months" :key="i" class="py-0 my-0">
                    
                    <span v-for="(date, subKey) in state" :key="subKey">
                        <v-row v-if="(parseInt(month.month) + 1) == parseInt(subKey.split('-')[1])" style="font-weight: bold;" :class="prop == 'delivered' ? calculateClass(parseFloat(date[prop + '_pct'].replace('%', ''))) : ''">
                            <v-col cols="5" justify="center" align="center"> 
                                {{ date[prop + '_total'] }}
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="5" justify="center" align="center">
                                {{ date[prop + '_pct'] }}
                            </v-col>
                        </v-row>
                    </span>
                    <v-row v-if="!(year.toString() + '-' + String(month.month + 1).padStart(2, '0') in state)" style="font-weight: bold;">
                        <v-col cols="5" justify="center" align="center"> 
                            <v-icon small>horizontal_rule</v-icon>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="5" justify="center" align="center">
                            <v-icon small>horizontal_rule</v-icon>                                
                        </v-col>
                    </v-row>
                
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

            <div class="horizontal-separator"></div>
        </span>
    </div>
</template>
<script>
    export default {
        props: [
            'data',
            'options',
            'selected_months',
            'showed_options',
            'year',
        ],
        data() {
            return {
                info: {},
                totals: {},
                month1: { sorted: false, direction: '' },
                month2: { sorted: false, direction: '' },
                month3: { sorted: false, direction: '' },
                state_with_most_deliveries: { name: "", value: 0}
            }
        },
        methods: {
            calculateClass(percentage) {
                if(percentage == 0) return "";
                else if(percentage >= this.options.green.min) return "green_text";
                else if(percentage >= this.options.yellow.min && percentage <= this.options.yellow.max) return "yellow_text";
                else return "red_text"; 
            },
            leftMonth() {
                this.$emit("leftMonth");
            },
            rightMonth() {
                this.$emit("rightMonth");
            },
            calculateTotals(){
                this.cleanSort();
                this.totals = {};
                
                for(let i = 0; i < this.selected_months.length; i++){
                    const curr_m = this.year.toString() + '-' + (this.selected_months[i].month + 1).toString().padStart(2, '0');
                    this.totals[curr_m] = {
                        total_shipments: 0,
                        delivered_total: 0,
                        delivered_pct: "0.00%",
                        returned_total: 0,
                        returned_pct: "0.00%",
                        others_total: 0,
                        others_pct: "0.00%"
                    }

                    for(let state in this.data){
                        if(curr_m in this.data[state]){
                            this.totals[curr_m].total_shipments += this.data[state][curr_m].total_shipments;
                            this.totals[curr_m].delivered_total += this.data[state][curr_m].delivered_total;
                            this.totals[curr_m].returned_total += this.data[state][curr_m].returned_total;
                            this.totals[curr_m].others_total += this.data[state][curr_m].others_total;
                        }
                    }

                    if(this.totals[curr_m].total_shipments > 0){
                        const percentage_by_order = (100 / this.totals[curr_m].total_shipments);

                        this.totals[curr_m].delivered_pct = (percentage_by_order * this.totals[curr_m].delivered_total).toFixed(2) + "%";
                        this.totals[curr_m].returned_pct = (percentage_by_order * this.totals[curr_m].returned_total).toFixed(2) + "%";
                        this.totals[curr_m].others_pct = (percentage_by_order * this.totals[curr_m].others_total).toFixed(2) + "%";
                    }
                }

                for(let state in this.data){
                    var total_pct = 0;

                    for(let i = 0; i < this.selected_months.length; i++){
                        const curr_m = this.year.toString() + '-' + (this.selected_months[i].month + 1).toString().padStart(2, '0');
                        
                        if(curr_m in this.data[state]) total_pct += parseFloat(this.data[state][curr_m].delivered_pct);
                    }

                    if (total_pct / 3 > this.state_with_most_deliveries.value ) {
                        this.state_with_most_deliveries.value = total_pct / 3;
                        this.state_with_most_deliveries.name = state;
                    }
                }
            },
            sortResults(obj, key = null, direction = "asc", month){
                if(direction == "") {
                    this.info = this.data;
                    return;
                }

                if((this[month] != this.month1 && this.month1.sorted == true) || (this[month] != this.month2 && this.month2.sorted == true) || (this[month] != this.month3 && this.month3.sorted == true)){
                    this.cleanSort();
                    return;
                }

                const entries = Object.entries(obj);

                const sorted = entries.sort(([, a], [, b]) => {
                    const keyA = key || Object.keys(a)[0];
                    const keyB = key || Object.keys(b)[0];

                    const hasA = a[keyA] !== undefined;
                    const hasB = b[keyB] !== undefined;

                    if (!hasA && !hasB) return 0;  
                    if (!hasA) return 1;           
                    if (!hasB) return -1;          

                    const valA = a[keyA].total_shipments;
                    const valB = b[keyB].total_shipments;

                    return direction === "asc" ? valA - valB : valB - valA;
                });

                this.info = sorted.reduce((acc, [k, v]) => {
                    acc[k] = v;
                    return acc;
                }, {});

            },
            cleanSort(){
                this.month1.sorted = false;
                this.month1.direction = "";

                this.month2.sorted = false;
                this.month2.direction = "";

                this.month3.sorted = false;
                this.month3.direction = "";
                
                this.info = this.data;
            }
        },
        watch: {
            'data': function(){
                this.info = this.data;
                this.calculateTotals();
            },
        }
    }
</script>